import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  @font-face {
    font-family: 'ReplicaLX';
    src: url(fonts/ReplicaLXRegular.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  html {
    font-size: 16px;
    height: 100%;
    box-sizing: border-box;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  body, #app {
    font-size: 12px;
    height: 100%;
    font-family: 'Verdana';
    overflow: hidden;
    color: ${props => props.theme.text.primary};
    background: ${props => props.theme.background};
    margin: 0;
    padding: 0;
    line-height: 1.5;
  }

  ::-webkit-scrollbar {
    background-color: ${props => props.theme.scrollBar.background};
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${props => props.theme.scrollBar.track};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar.thumb};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: ${props => props.theme.scrollBar.thumbHover};
  }

  a {
    color: ${props => props.theme.text.secondary};

    &:focus, &:hover {
      color: ${props => props.theme.text.secondary};
    }
  }
  button {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;

    display: flex;
    align-content: center;
    justify-content: center;
    justify-items: center;
    align-items: center;

    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;

    background: transparent;
    padding: 0;
    border: 0;
    border-radius: 0;
    line-height: 0;
  }
  button, input, optgroup, select, textarea {
    font: inherit;
    margin: 0;
    color: inherit;
  }

  input[type="search"] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
`;



// WEBPACK FOOTER //
// ./app/styled-components/GlobalStyle.js